// const hostname = window.location.hostname;

// let apiUrl = '';

// if (hostname.includes('localhost')) {
//     apiUrl = process.env.REACT_APP_API_LOCAL_URL!;
// } else if (hostname.includes('hmg.decatron.com.br')) {
//     apiUrl = process.env.REACT_APP_API_DEV_URL!;
// } else if (hostname.includes('www.decatron.com.br') || hostname === 'decatron.com.br') {
//     apiUrl = process.env.REACT_APP_API_PROD_URL!;
// } else {
//     console.warn('Ambiente não reconhecido, usando API local como fallback');
//     apiUrl = process.env.REACT_APP_API_LOCAL_URL!;
// }

export const API_NEWS_URL = process.env.REACT_APP_API_DEV_URL || 'http://localhost:3000/';
